<script setup>
import { ref } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Input from 'dashboard/components-next/input/Input.vue';

const props = defineProps({
  placeholder: {
    type: String,
    default: '',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
  confirmLabel: {
    type: String,
    default: '',
  },
  cancelLabel: {
    type: String,
    default: '',
  },
  // Título e apoio do diálogo; sem eles, cai no rótulo do botão.
  dialogTitle: {
    type: String,
    default: '',
  },
  dialogDescription: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['add']);

const modelValue = defineModel({
  type: String,
  default: '',
});

// Era um popover flutuante: sem sobreposição, sem foco preso e cortado em tela
// estreita. Agora usa o diálogo do sistema, como os demais formulários da área.
const dialogRef = ref(null);
const inputRef = ref(null);

const openDialog = () => {
  modelValue.value = '';
  dialogRef.value?.open();
};

const onClickAdd = () => {
  const content = modelValue.value?.trim();
  if (!content) return;

  emit('add', content);
  modelValue.value = '';
  dialogRef.value?.close();
};
</script>

<template>
  <div class="inline-flex">
    <Button
      :label="buttonLabel"
      size="sm"
      color="slate"
      class="flex-shrink-0"
      @click="openDialog"
    />
    <Dialog
      ref="dialogRef"
      type="edit"
      :title="props.dialogTitle || buttonLabel"
      :description="props.dialogDescription"
      :confirm-button-label="confirmLabel"
      :cancel-button-label="cancelLabel"
      :disable-confirm-button="!modelValue?.trim()"
      @confirm="onClickAdd"
    >
      <Input
        ref="inputRef"
        v-model="modelValue"
        :placeholder="placeholder"
        @keyup.enter="onClickAdd"
      />
    </Dialog>
  </div>
</template>
